<template>
  <div v-if="authenticatedUser">
    <b-container>
      <!-- Bookmarked Recipes -->
      <RecipesSection type="BOOKMARKED"/>
      <!-- Bookmarked Resources -->
      <ResourcesSection type="BOOKMARKED"/>
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import RecipesSection from '../components/recipes/RecipesSection'
import ResourcesSection from '../components/resources/ResourcesSection'

export default {
  name: 'bookmarks',
  components: {
    RecipesSection, ResourcesSection
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Bookmarks.vue